import { Campaign, FitProfile, FitRequirements, UserInDetails } from '@hub/shared'
import RegisterRequirements from '@pages/summary/components/register-requirements/register-requirements.component'
import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  campaign: Campaign
  fitRequirements?: FitRequirements
  userSelected: UserInDetails
  onChange?: (value: any) => any
}

export default ({ campaign, userSelected, fitRequirements, onChange }: Props) => {
  const [t] = useTranslation('preRecruitment')

  const handleChange = useCallback(
    (value: boolean) => {
      if (onChange && typeof onChange === 'function') {
        onChange(value)
      }
    },
    [onChange]
  )

  const handleVerifyRequirements = useCallback((): boolean => {
    const fitRequirementsUser = fitRequirements?.fits?.fitProfile
    return fitRequirementsUser ? fitRequirementsUser?.every((fit: FitProfile) => fit?.fit) : true
  }, [fitRequirements])

  useEffect(() => {
    handleChange(handleVerifyRequirements())
    if (!campaign?.activation?.suggestion) {
      handleChange(true)
    }
  }, [userSelected, handleChange, campaign, handleVerifyRequirements])

  const returnDescription = () => {
    if (userSelected?.status !== 'recruited' && campaign?.activation?.proposal) {
      return campaign?.activation?.proposal
    }
    return campaign?.activation?.description
  }

  return (
    <section className="pre-recruitment opportunity">
      <hr />
      <div className="content">
        <h5>{t('detailsTitle')}</h5>
        <div className="clean-style" dangerouslySetInnerHTML={{ __html: returnDescription() }}></div>
      </div>
      {!userSelected?.status && fitRequirements?.fits?.fitProfile?.length ? (
        <div>
          <hr />
          <div className="content">
            <RegisterRequirements suggestionRules={campaign?.activation?.suggestionRules} fitRequirements={fitRequirements} />
          </div>
        </div>
      ) : null}
    </section>
  )
}
